import { useState } from "react";
import { useSearchNbaPlayersQuery } from "../store/api/nbaApi";
import { getNbaDisplayName } from "../adapters/nbaPlayerAdapter";

export const useNbaPlayerSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const searchQuery = useSearchNbaPlayersQuery(
    searchTerm.length >= 2 ? searchTerm : null,
    {
      skip: searchTerm.length < 2,
    }
  );

  const handleSearchInputChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
  };

  const getPlayerOptionLabel = (option) => {
    if (!option) return "";
    return getNbaDisplayName(option);
  };

  const isPlayerOptionEqualToValue = (option, value) => {
    if (!option || !value) return false;
    return option.playerId === value.playerId;
  };

  const renderPlayerOption = (props, option) => {
    const displayName = getNbaDisplayName(option);
    const points =
      option.popularityScore ??
      option.stats?.totals?.career?.pts ??
      "0";
    const position = option.bio?.position || option.bioData?.position;

    const { key, ...otherProps } = props;

    return (
      <li key={option.playerId || key} {...otherProps}>
        <div>
          <div style={{ fontWeight: "bold" }}>{displayName}</div>
          <div style={{ fontSize: "0.875rem", color: "#666" }}>
            {position ? `${position} · ` : ""}PTS: {points}
          </div>
        </div>
      </li>
    );
  };

  return {
    searchTerm,
    searchQuery,
    handleSearchInputChange,
    getPlayerOptionLabel,
    isPlayerOptionEqualToValue,
    renderPlayerOption,
  };
};
